import { render, staticRenderFns } from "./TripReview.vue?vue&type=template&id=ddf96c00&"
import script from "./TripReview.vue?vue&type=script&lang=js&"
export * from "./TripReview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports